import {useMutation} from 'react-query'

import {mutations} from '../../mutations'

export const usePostNotificationSettings = () => {
  return useMutation(mutations.postNotificationSettings)
}
